export default __webpack_public_path__ + "static/media/a9e43ecb3c9c19232b498944f33eaf6a.svg";